import React from 'react'

import { IconProps } from '../Types'

export const WheelFill = ({
  title,
  fill = 'currentColor',
  stroke = 'none',
  ref,
  ...props
}: IconProps) => (
  <svg
    ref={ref}
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    data-title="WheelFill"
    {...{ ...(title && { 'data-title': title }), fill, stroke, ...props }}
    dangerouslySetInnerHTML={{
      __html:
        (title === undefined ? '' : `<title>${title}</title>`) +
        '<path d="m20.67,14.18l-.9-1.09v-1.93l.9-1.09c.25-.34.41-.76.49-1.18,0-.42-.08-.92-.25-1.26l-.57-1.01c-.25-.34-.49-.67-.9-.84-.41-.17-.82-.25-1.23-.17l-1.4.25-1.64-.92-.49-1.34c-.16-.42-.41-.76-.82-1.01-.49-.5-.9-.59-1.31-.59h-1.15c-.41,0-.82.17-1.23.42-.33.25-.66.59-.82,1.01l-.49,1.26-1.64.92-1.4-.17c-.41-.08-.82,0-1.23.17-.41.17-.74.5-.9.84l-.57,1.09c-.16.34-.33.84-.25,1.26,0,.42.16.84.49,1.18l.9,1.09v1.93l-.9,1.09c-.25.34-.41.76-.49,1.18,0,.42.08.92.25,1.26l.57,1.01c.25.34.49.67.9.84.41.17.82.25,1.23.17l1.4-.25,1.64.92.49,1.34c.16.42.41.76.82,1.01.33.25.74.42,1.23.42h1.15c.41,0,.82-.17,1.23-.42.33-.25.66-.59.82-1.01l.49-1.34,1.64-.92,1.4.25c.41.08.82,0,1.23-.17.41-.17.66-.5.9-.84l.57-1.01c.25-.42.33-.84.33-1.26-.08-.34-.25-.76-.49-1.09Zm-6.65-1.68c-.08.42-.25.76-.57,1.09-.33.34-.66.5-1.07.59s-.82,0-1.23-.08c-.41-.17-.74-.42-.9-.76-.25-.42-.33-.84-.33-1.26,0-.59.25-1.09.57-1.51.41-.42.9-.59,1.48-.59.41,0,.82.08,1.15.34.33.25.57.59.74.92.16.42.25.84.16,1.26Z"/>',
    }}
  />
)

WheelFill.displayName = 'WheelFill'

export const tags = ['WheelFill', '']
